import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
export function ScrollManager() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const target = document.querySelector(hash);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        return;
      }
    }
    window.scrollTo({
      top: 0,
      left: 0
    });
  }, [pathname, hash]);
  return null;
}